export default __webpack_public_path__ + "static/media/google.fb77b889.png";